import get from 'lodash/get';
import * as service from 'services';
import { useCreateDispatches } from 'helpers/hooks';

export function useGetAgencyActivity({
	setActivity,
	setlastPostActivityId,
} = {}) {
	const { setSnackbar } = useCreateDispatches();

	const params = {
		callback: service.getAgencyActivity,
		dataPath: `data.agencyActivities`,
	};

	if (!params || !params.callback) return () => Promise.resolve(null);

	return async (agencyId) => {
		return await service
			.getAgencyActivity(agencyId)
			.then((result) => {
				setActivity?.(get(result, params.dataPath));
				setlastPostActivityId(get(result, 'data.lastPostActivityId') || null);
				return result;
			})
			.catch((err) => {
				setActivity([]);
				setSnackbar(
					{
						variant: 'error',
						message:
							err.response?.data.message ||
							'Something went wrong. Please try again later',
					},
					{ log: true }
				);
			});
	};
}
